"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromOperationError = exports.toOperationError = exports.toRPCTransferOperation = exports.fromTxOperation = exports.toTxOperation = exports.fromOriginateParams = exports.toOriginateParams = exports.fromSendParams = exports.toSendParams = exports.fromRevealParams = exports.toRevealParams = exports.fromEstimate = exports.toEstimate = exports.toSignResult = exports.toBlock = exports.toTransferConfirmation = exports.toOriginationOperation = exports.toOperationStatus = exports.toTransferParams = exports.fromTransferParams = exports.toTransferParamsWithTransactionKind = void 0;
var taquito_1 = __importDefault(require("@taquito/taquito"));
var rpc_1 = require("@taquito/rpc");
var toTransferParamsWithTransactionKind = function (response) { return (__assign(__assign({}, (0, exports.fromTransferParams)(response)), { kind: rpc_1.OpKind.TRANSACTION })); };
exports.toTransferParamsWithTransactionKind = toTransferParamsWithTransactionKind;
var fromTransferParams = function (receipt) { return ({
    to: receipt.to,
    amount: receipt.amount,
    source: receipt.source ? receipt.source : undefined,
    fee: receipt.fee ? receipt.fee : undefined,
    gasLimit: receipt.gasLimit ? receipt.gasLimit : undefined,
    storageLimit: receipt.storageLimit ? receipt.storageLimit : undefined,
    mutez: receipt.mutez ? receipt.mutez : undefined,
    parameter: receipt.parameter ? JSON.parse(receipt.parameter) : undefined,
}); };
exports.fromTransferParams = fromTransferParams;
var toTransferParams = function (receipt) { return ({
    to: receipt.to,
    amount: receipt.amount,
    source: receipt.source,
    fee: receipt.fee,
    gasLimit: receipt.gasLimit,
    storageLimit: receipt.storageLimit,
    mutez: receipt.mutez,
    parameter: JSON.stringify(receipt.parameter)
}); };
exports.toTransferParams = toTransferParams;
var toOperationStatus = function (response) { return ({
    hash: response.hash,
    type: response.type,
    block: response.block,
    time: response.time,
    height: response.hash,
    cycle: response.cycle,
    counter: response.counter,
    status: response.status,
    is_success: response.is_success,
    is_contract: response.is_contract,
    gas_limit: response.gas_limit,
    gas_used: response.gas_used,
    gas_price: response.gas_price,
    storage_limit: response.storage_limit,
    storage_size: response.storage_size,
    storage_paid: response.storage_paid,
    volume: response.volume,
    fee: response.fee,
    days_destroyed: response.days_destroyed,
    sender: response.sender,
    receiver: response.receiver,
    confirmations: response.confirmations
}); };
exports.toOperationStatus = toOperationStatus;
var toOriginationOperation = function (receipt) { return ({
    contractAddress: receipt.contractAddress,
    hash: receipt.hash,
    consumedGas: receipt.consumedGas ? receipt.consumedGas : undefined,
    errors: receipt.errors
        ? receipt.errors.map(function (err) { return (0, exports.toOperationError)(err); })
        : [],
    fee: receipt.fee,
    gasLimit: receipt.gasLimit,
    includedInBlock: receipt.includedInBlock,
    revealStatus: receipt.revealStatus,
    status: receipt.status,
    storageDiff: receipt.storageDiff ? receipt.storageDiff : undefined,
    storageLimit: receipt.storageLimit,
    storageSize: receipt.storageSize ? receipt.storageSize : undefined,
}); };
exports.toOriginationOperation = toOriginationOperation;
var toTransferConfirmation = function (receipt) { return ({
    completed: receipt.completed,
    currentConfirmation: receipt.currentConfirmation,
    expectedConfirmation: receipt.expectedConfirmation,
    block: (0, exports.toBlock)(receipt.block),
}); };
exports.toTransferConfirmation = toTransferConfirmation;
var toBlock = function (receipt) { return ({
    chainId: receipt.chain_id,
    hash: receipt.hash,
    protocol: receipt.protocol,
}); };
exports.toBlock = toBlock;
var toSignResult = function (receipt) { return ({
    bytes: receipt.bytes,
    sig: receipt.sig,
    prefixSig: receipt.prefixSig,
    sbytes: receipt.sbytes,
}); };
exports.toSignResult = toSignResult;
var toEstimate = function (receipt) { return ({
    burnFeeMutez: receipt.burnFeeMutez,
    gasLimit: receipt.gasLimit,
    minimalFeeMutez: receipt.minimalFeeMutez,
    opSize: receipt.opSize.toString(),
    storageLimit: receipt.storageLimit,
    suggestedFeeMutez: receipt.suggestedFeeMutez,
    totalCost: receipt.totalCost,
    usingBaseFeeMutez: receipt.usingBaseFeeMutez,
    consumedMilligas: receipt.consumedMilligas,
}); };
exports.toEstimate = toEstimate;
var fromEstimate = function (receipt) { return ({
    burnFeeMutez: receipt.burnFeeMutez,
    gasLimit: receipt.gasLimit,
    minimalFeeMutez: receipt.minimalFeeMutez,
    opSize: receipt.opSize,
    storageLimit: receipt.storageLimit,
    suggestedFeeMutez: receipt.suggestedFeeMutez,
    totalCost: receipt.totalCost,
    usingBaseFeeMutez: receipt.usingBaseFeeMutez,
    consumedMilligas: receipt.consumedMilligas,
}); };
exports.fromEstimate = fromEstimate;
var toRevealParams = function (receipt) { return ({
    fee: receipt.fee ? receipt.fee : undefined,
    gasLimit: receipt.gasLimit ? receipt.gasLimit : undefined,
    storageLimit: receipt.storageLimit ? receipt.storageLimit : undefined,
}); };
exports.toRevealParams = toRevealParams;
var fromRevealParams = function (receipt) { return ({
    fee: receipt.fee ? receipt.fee : undefined,
    gasLimit: receipt.gasLimit ? receipt.gasLimit : undefined,
    storageLimit: receipt.storageLimit ? receipt.storageLimit : undefined,
}); };
exports.fromRevealParams = fromRevealParams;
var toSendParams = function (receipt) { return ({
    to: receipt.to,
    amount: receipt.amount,
    source: receipt.source,
    fee: receipt.fee,
    gasLimit: receipt.gasLimit,
    storageLimit: receipt.storageLimit,
    mutez: receipt.mutez,
}); };
exports.toSendParams = toSendParams;
var fromSendParams = function (receipt) { return ({
    to: receipt.to,
    amount: receipt.amount,
    source: receipt.source ? receipt.source : undefined,
    fee: receipt.fee ? receipt.fee : undefined,
    gasLimit: receipt.gasLimit ? receipt.gasLimit : undefined,
    storageLimit: receipt.storageLimit ? receipt.storageLimit : undefined,
    mutez: receipt.mutez ? receipt.mutez : undefined,
}); };
exports.fromSendParams = fromSendParams;
var toOriginateParams = function (receipt) { return ({
    code: receipt.code,
    storage: receipt.storage,
    balance: receipt.balance,
    delegate: receipt.delegate,
    fee: receipt.fee,
    gasLimit: receipt.gasLimit,
    storageLimit: receipt.storageLimit,
    mutez: receipt.mutez,
}); };
exports.toOriginateParams = toOriginateParams;
var fromOriginateParams = function (receipt) { return ({
    code: receipt.code,
    storage: receipt.storage,
    balance: receipt.balance ? receipt.balance : undefined,
    delegate: receipt.delegate ? receipt.delegate : undefined,
    fee: receipt.fee ? receipt.fee : undefined,
    gasLimit: receipt.gasLimit ? receipt.gasLimit : undefined,
    storageLimit: receipt.storageLimit ? receipt.storageLimit : undefined,
    mutez: receipt.mutez ? receipt.mutez : undefined,
    init: receipt.init ? receipt.init : undefined,
}); };
exports.fromOriginateParams = fromOriginateParams;
var toTxOperation = function (receipt) { return ({
    hash: receipt.hash,
    source: receipt.source || "",
    amount: receipt.amount.toString(),
    consumedGas: receipt.consumedGas,
    destination: receipt.destination,
    errors: receipt.errors.map(exports.toOperationError),
    fee: receipt.fee,
    gasLimit: receipt.gasLimit,
    includedInBlock: receipt.includedInBlock.toString(),
    status: receipt.status.toString(),
    storageDiff: receipt.storageDiff,
    storageLimit: receipt.storageLimit,
    storageSize: receipt.storageSize,
}); };
exports.toTxOperation = toTxOperation;
var fromTxOperation = function (receipt) {
    return new taquito_1.default.TransactionOperation(receipt.hash, (0, exports.toRPCTransferOperation)(receipt), receipt.source, {}, [], undefined);
};
exports.fromTxOperation = fromTxOperation;
var toRPCTransferOperation = function (receipt) { return ({
    amount: receipt.amount || "",
    destination: receipt.destination,
    fee: receipt.fee,
    gas_limit: receipt.gasLimit,
    kind: taquito_1.default.OpKind.TRANSACTION,
    source: receipt.source || "",
    storage_limit: receipt.storageLimit,
}); };
exports.toRPCTransferOperation = toRPCTransferOperation;
var toOperationError = function (error) { return ({
    id: error.id,
    kind: error.kind,
}); };
exports.toOperationError = toOperationError;
var fromOperationError = function (error) { return ({
    id: error.id,
    kind: error.kind,
}); };
exports.fromOperationError = fromOperationError;
//# sourceMappingURL=mapping.js.map